<section class="flow-card" [class.flow-card-expanded]="collapsible && expanded()" [attr.aria-labelledby]="titleId" [attr.aria-describedby]="subtext ? subtextId : null">
  <header
    class="flow-card-header"
    [class.flow-card-header-clickable]="collapsible"
    [attr.role]="collapsible ? 'button' : null"
    [attr.tabindex]="collapsible ? 0 : null"
    [attr.aria-expanded]="collapsible ? expanded() : null"
    [attr.aria-controls]="collapsible ? contentId : null"
    [attr.aria-label]="collapsible ? chevronAriaLabel : null"
    (click)="onHeaderClick()"
    (keydown.enter)="onHeaderKeydown($event)"
    (keydown.space)="onHeaderKeydown($event)">
    <div class="flow-card-title-group">
      @if (showCheckbox) {
        <flow-checkbox-v2
          class="flow-card-checkbox"
          [checked]="checkboxChecked()"
          [radio]="checkboxType === 'radio'"
          [disabled]="checkboxDisabled"
          [ariaLabel]="checkboxAriaLabel"
          (click)="onCheckboxToggle(); $event.stopPropagation()"
          (keydown.space)="onCheckboxToggle(); $event.stopPropagation()"></flow-checkbox-v2>
      }

      @if (leadingIcon) {
        <span class="flow-card-icon-wrapper" [class.flow-card-icon-boxed]="leadingIconVariant === 'boxed'">
          <img class="flow-card-icon" [src]="leadingIcon" alt="" aria-hidden="true" />
        </span>
      }

      <div class="flow-card-copy">
        <div class="flow-card-title-row">
          @if (titleIcon) {
            <img class="flow-card-title-icon" [src]="titleIcon" alt="" aria-hidden="true" />
          }

          <span [id]="titleId" class="flow-card-title" role="heading" [attr.aria-level]="headingLevel" [agText]="titleTextStyle">{{ title }}</span>

          @if (inlineBadge; as badge) {
            <flow-badge-v2
              [text]="badge.text"
              [color]="badge.color ?? 'Neutral'"
              [type]="badge.type ?? 'Subtle'"
              [icon]="badge.icon ?? ''"
              size="Small"></flow-badge-v2>
          }
        </div>

        @if (subtext) {
          <p [id]="subtextId" class="flow-card-subtext" agText="body-3">{{ subtext }}</p>
        }
      </div>
    </div>

    @if (hasActions) {
      <div class="flow-card-actions">
        @for (action of resolvedActions; track action.id) {
          <flow-button-v2
            [label]="action.label ?? ''"
            [type]="action.type ?? 'secondary'"
            size="small"
            [icon]="action.icon ?? ''"
            [disabled]="action.disabled ?? false"
            [loading]="action.loading ?? false"
            [ariaLabel]="action.ariaLabel ?? ''"
            (click)="onActionClick(action, $event); $event.stopPropagation()"></flow-button-v2>
        }
        @if (showOverflow) {
          <flow-button-v2
            type="secondary"
            size="small"
            [icon]="iconService.Icon.kebab_menu"
            [ariaLabel]="overflowAriaLabel"
            (click)="overflowClick.emit($event); $event.stopPropagation()"></flow-button-v2>
        }
      </div>
    }

    @if (resolvedTrailingBadge; as badge) {
      <flow-badge-v2
        [text]="badge.text"
        [color]="badge.color ?? 'Neutral'"
        [type]="badge.type ?? 'Subtle'"
        [icon]="badge.icon ?? ''"
        size="Large"></flow-badge-v2>
    }

    @if (disabledText) {
      <span class="flow-card-disabled-text" agText="body-2-medium">{{ disabledText }}</span>
    }

    @if (collapsible) {
      <button
        type="button"
        class="flow-card-chevron"
        [class.flow-card-chevron-expanded]="expanded()"
        [attr.aria-expanded]="expanded()"
        [attr.aria-controls]="contentId"
        [attr.aria-label]="chevronAriaLabel"
        tabindex="-1"
        (click)="toggleExpanded(); $event.stopPropagation()">
        <img [src]="iconService.Icon.down_1" alt="" aria-hidden="true" />
      </button>
    }
  </header>

  <div [id]="contentId" class="flow-card-body" [style.padding]="bodyPadding" [hidden]="collapsible && !expanded()">
    <ng-content></ng-content>
  </div>
</section>
